/**
 * Returns an onClick handler that prevents default navigation and opens a modal.
 * Use as: onClick={openModal(setIsModalOpen)}
 */
export const openModal = (setter) => (e) => {
  e.preventDefault()
  setter(true)
}
